<div class="modal-header">
  <h1 class="modal-title fs-5" id="viewBookingDetailsLabel">Tracking</h1>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div *ngIf="booking" class="row row-cols-1 row-cols-md-3 g-2 mb-3">

    <!-- Pick-up card -->
    <div class="col">
      <div class="card h-100 shadow">
        <div class="card-header text-center bg-primary p-0">
          <h2 class="fs-5 text-white m-0">Pick-up address</h2>
        </div>
        <div class="card-body text-center p-1">
          <p class="mb-0 fs-6 text-secondary">
            {{booking.pickUpAddress}}, {{booking.fromSuburb}}, {{booking.pickUpPCode}}
          </p>
        </div>
      </div>
    </div>
    <!-- Pick-up card -->

    <!-- Middle image -->
    <div class="col d-none d-md-block">
      <div class="card h-100 border-0">
        <div class="card-body d-flex justify-content-center align-items-center">
          <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary opacity-75" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary opacity-50" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger opacity-50" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger opacity-75" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
        </div>
      </div>
    </div>
    <!-- Middle image -->

    <!-- Drop-off card -->
    <div class="col">
      <div class="card h-100 shadow">
        <div class="card-header text-center bg-danger p-0">
          <h2 class="fs-5 text-white m-0">Drop-off address</h2>
        </div>
        <div class="card-body text-center p-1">
          <p class="mb-0 fs-6 text-secondary">
            {{booking.dropOffAddress}}, {{booking.toSuburb}}, {{booking.dropOffPCode}}
          </p>
        </div>
      </div>
    </div>
    <!-- Drop-off card -->

  </div>

  <div class="card shadow mb-4">
  <div class="card-header d-flex flex-column d-md-flex flex-md-row justify-content-md-between">
    <h4 class="text-danger m-0">Tracking events</h4>
    <h4 class="text-danger m-0">{{trackNo.trackNo}}</h4>
  </div>

  <div class="card-body">
    <div class="col text-center px-2 mt-2">
      <div *ngIf="trackingEvents?.length; else noEvents" class="table-responsive rounded-2">
        <table class="table table-hover table-sm align-middle">
          <thead>
          <tr>
            <th class="text-secondary">No</th>
            <th class="text-secondary">Description</th>
            <th class="text-secondary">Date</th>
            <th class="text-secondary">Time</th>
            <th class="text-secondary">Location</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let trackEvent of trackingEvents; let i = index" class="table-light">
            <td class="text-secondary">{{i + 1}}</td>
            <td class="text-secondary">
              {{trackEvent.TrackingEventName}}
              <small *ngIf="trackEvent.TrackingNotes" class="d-block text-muted">
                {{trackEvent.TrackingNotes}}
              </small>
            </td>
            <td class="text-secondary">{{trackEvent.TrackingDate | slice:0:10}}</td>
            <td class="text-secondary">{{trackEvent.TrackingDate | slice:11}}</td>
            <td class="text-secondary">{{trackEvent.TrackingLocation}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noEvents>
        <p class="text-secondary mb-0">No tracking events yet</p>
      </ng-template>
    </div>
  </div>
</div>
</div>

<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-danger w-25" (click)="closeModal()">
    Close
  </button>
</div>
